import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import SmsDetail from "@/pages/Pages/Report/Detail/SmsDetail.vue";
import SmsDetailInfo from "@/pages/Pages/Report/Detail/SmsDetailInfo.vue";
import CallDetail from "@/pages/Pages/Report/Detail/CallDetail.vue";
import CallDetailInfo from "@/pages/Pages/Report/Detail/CallDetailInfo.vue";
import EmailDetail from "@/pages/Pages/Report/Detail/EmailDetail.vue";
import EmailDetailInfo from "@/pages/Pages/Report/Detail/EmailDetailInfo.vue";
import PushDetail from "@/pages/Pages/Report/Detail/PushDetail.vue";
import PushDetailInfo from "@/pages/Pages/Report/Detail/PushDetailInfo.vue";
import ViberDetail from "@/pages/Pages/Report/Detail/ViberDetail.vue";
import ViberDetailInfo from "@/pages/Pages/Report/Detail/ViberDetailInfo.vue";
import WhatsappDetail from "@/pages/Pages/Report/Detail/WhatsappDetail.vue";
import WhatsappDetailInfo from "@/pages/Pages/Report/Detail/WhatsappDetailInfo.vue";
import CustomDetail from "@/pages/Pages/Report/Detail/CustomDetail.vue";
import CustomDetailInfo from "@/pages/Pages/Report/Detail/CustomDetailInfo.vue";
import MailNotifyDetail from "@/pages/Pages/Report/Detail/MailNotifyDetail.vue";
import MailNotifyDetailInfo from "@/pages/Pages/Report/Detail/MailNotifyDetailInfo.vue";

import SmsGroup from "@/pages/Pages/Report/Group/SmsGroup.vue";
import CallGroup from "@/pages/Pages/Report/Group/CallGroup.vue";
import EmailGroup from "@/pages/Pages/Report/Group/EmailGroup.vue";
import PushGroup from "@/pages/Pages/Report/Group/PushGroup.vue";
import ViberGroup from "@/pages/Pages/Report/Group/ViberGroup.vue";
import WhatsappGroup from "@/pages/Pages/Report/Group/WhatsappGroup.vue";
import CustomGroup from "@/pages/Pages/Report/Group/CustomGroup.vue";
import MailNotifyGroup from "@/pages/Pages/Report/Group/MailNotifyGroup.vue";
import SummaryGroup from "@/pages/Pages/Report/Group/Summary.vue";

import Reports from "@/pages/Pages/Report/Reports.vue";

let reportMenu = {
  path: "/",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "report/detailed/sms",
      name: "report_detailed_sms",
      component: SmsDetail,
      meta: {
        icon: "sms",
        msgKey: 'menu.item.statistics.detail.sms'
      }
    },
    {
      path: "report/detailed/sms/:id",
      name: "report_detailed_sms_info",
      component: SmsDetailInfo,
      meta: {
        icon: "sms",
        parentPath: "/report/detailed/sms",
        msgKey: 'menu.item.statistics.detail.sms'
      }
    },
    {
      path: "report/detailed/call",
      name: "report_detailed_call",
      component: CallDetail,
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.detail.call'
      }
    },
    {
      path: "report/detailed/call/:id",
      name: "report_detailed_call_info",
      component: CallDetailInfo,
      meta: {
        icon: "call",
        parentPath: "/report/detailed/call",
        msgKey: 'menu.item.statistics.detail.call'
      }
    },
    {
      path: "report/detailed/email",
      name: "report_detailed_email",
      component: EmailDetail,
      meta: {
        icon: "email",
        msgKey: 'menu.item.statistics.detail.email'
      }
    },
    {
      path: "report/detailed/email/:id",
      name: "report_detailed_email_info",
      component: EmailDetailInfo,
      meta: {
        icon: "email",
        parentPath: "/report/detailed/email",
        msgKey: 'menu.item.statistics.detail.email'
      }
    },
    {
      path: "report/detailed/push",
      name: "report_detailed_push",
      component: PushDetail,
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.statistics.detail.push'
      }
    },
    {
      path: "report/detailed/push/:id",
      name: "report_detailed_push_info",
      component: PushDetailInfo,
      meta: {
        icon: "notifications",
        parentPath: "/report/detailed/push",
        msgKey: 'menu.item.statistics.detail.push'
      }
    },
    {
      path: "report/detailed/viber",
      name: "report_detailed_viber",
      component: ViberDetail,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.statistics.detail.viber'
      }
    },
    {
      path: "report/detailed/viber/:id",
      name: "report_detailed_viber_info",
      component: ViberDetailInfo,
      meta: {
        icon: "forum",
        parentPath: "/report/detailed/viber",
        msgKey: 'menu.item.statistics.detail.viber'
      }
    },
    {
      path: "report/detailed/whatsapp",
      name: "report_detailed_whatsapp",
      component: WhatsappDetail,
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.statistics.detail.whatsapp'
      }
    },
    {
      path: "report/detailed/whatsapp/:id",
      name: "report_detailed_whatsapp_info",
      component: WhatsappDetailInfo,
      meta: {
        icon: "whatsapp",
        parentPath: "/report/detailed/whatsapp",
        msgKey: 'menu.item.statistics.detail.whatsapp'
      }
    },
    {
      path: "report/detailed/custom",
      name: "report_detailed_custom",
      component: CustomDetail,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.statistics.detail.custom'
      }
    },
    {
      path: "report/detailed/custom/:id",
      name: "report_detailed_custom_info",
      component: CustomDetailInfo,
      meta: {
        icon: "forum",
        parentPath: "/report/detailed/custom",
        msgKey: 'menu.item.statistics.detail.custom'
      }
    },
    {
      path: "report/detailed/mail_notify",
      name: "report_detailed_mail_notify",
      component: MailNotifyDetail,
      meta: {
        icon: "mark_email_unread",
        msgKey: 'menu.item.statistics.detail.mail_notify'
      }
    },
    {
      path: "report/detailed/mail_notify/:id",
      name: "report_detailed_mail_notify_info",
      component: MailNotifyDetailInfo,
      meta: {
        icon: "mark_email_unread",
        parentPath: "/report/detailed/mail_notify",
        msgKey: 'menu.item.statistics.detail.mail_notify'
      }
    },

    {
      path: "report/group/sms",
      name: "report_group_sms",
      component: SmsGroup,
      meta: {
        icon: "sms",
        msgKey: 'menu.item.statistics.group.sms'
      }
    },
    {
      path: "report/group/call",
      name: "report_group_call",
      component: CallGroup,
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.group.call'
      }
    },
    {
      path: "report/group/email",
      name: "report_group_email",
      component: EmailGroup,
      meta: {
        icon: "email",
        msgKey: 'menu.item.statistics.group.email'
      }
    },
    {
      path: "report/group/push",
      name: "report_group_push",
      component: PushGroup,
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.statistics.group.push'
      }
    },
    {
      path: "report/group/viber",
      name: "report_group_viber",
      component: ViberGroup,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.statistics.group.viber'
      }
    },
    {
      path: "report/group/whatsapp",
      name: "report_group_whatsapp",
      component: WhatsappGroup,
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.statistics.group.whatsapp'
      }
    },
    {
      path: "report/group/custom",
      name: "report_group_custom",
      component: CustomGroup,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.statistics.group.custom'
      }
    },
    {
      path: "report/group/mail_notify",
      name: "report_group_mail_notify",
      component: MailNotifyGroup,
      meta: {
        icon: "mark_email_unread",
        msgKey: 'menu.item.statistics.group.mail_notify'
      }
    },
    {
      path: "report/group/summary",
      name: "report_group_summary",
      component: SummaryGroup,
      meta: {
        icon: 'leaderboard',
        msgKey: 'menu.item.statistics.group.general'
      }
    },
    {
      path: "report/export",
      name: "report_export",
      component: Reports,
      meta: {
        icon: 'download',
        msgKey: 'menu.item.export.reports'
      }
    },
  ]
};

export default reportMenu;